import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import {LoggerService} from './logger-service';
// import {electricityMeterBase} from '../model/meter/electricityMeterBase';



@Injectable()
export class MeterData {
  meterdata: any;
  meterinfo: any;


  constructor(public http: Http,
              private logger: LoggerService) {

    this.logger.log.debug('Hello MeterData Provider');
  }

  load(): any {
      this.logger.log.debug('load: ');
      this.logger.log.debug(this.http);
      return this.http.get('assets/data/solarAnalytics/mockData.json')
        .map(this.processData, this);

  }

  processData(data: any) {
    // do the nifty stuff here
    this.logger.log.debug('function input: ');
    this.logger.log.debug(data);

    let myJSONData = JSON.stringify(data);

    this.logger.log.debug('Stringified input: ');
    this.logger.log.debug(myJSONData);

    this.meterdata = myJSONData;

    this.logger.log.debug('Meterdata input: ');
    this.logger.log.debug(this.meterdata);


    this.logger.log.debug('Meterdata input: ');
    this.logger.log.debug(this.meterdata.data);

    this.logger.log.debug('Instantiate: ');

//    let myMeter: new electricityMeterBase(this.meterdata.data.polarity);

    // // data -> data is where the intesting stuff is
    // this.meterdata.forEach((data: any) => {
    //
    //   this.logger.log.debug(data);
    //
    //   this.meterinfo.polarity = data.polarity;
    //   this.meterinfo.watt_device_id = data.watt_device_id;
    //   this.meterinfo.circuit = data.circuit;
    //   this.meterinfo.circuit_name = data.circuit_name;
    //   this.meterinfo.monitors = data.monitors;
    //
    //   // loop through each timeline group in the day
    //   // data.data.forEach((interval: any) => {
    //   //   // TODO: we need to think about how to structure data here - create model class.
    //   //   // this.apparentPower =
    //   // });
    // });


    this.logger.log.debug('Finished loop');

    return this.meterinfo
  };

  getPolarity(): number {
    //TODO: move this to a model class
    this.logger.log.debug('Polarity');
    this.logger.log.debug(this.meterinfo);
    return this.meterinfo.polarity;
  }

}



// WEBPACK FOOTER //
// ./src/providers/meter-data.ts